import { PalletSpecification, PalletType } from 'interfaces';

export const calculatePalletsAmountAsLogisticMinimum = (
   type: PalletType,
   amount: number,
   palletTypesData: PalletSpecification[],
) => {
   const palletTypeData = palletTypesData.find(palletTypeItem => palletTypeItem.name === type);
   return palletTypeData ? amount / palletTypeData.logisticMinimum : 0;
};
